import { createSelector } from '@ngrx/store';

import { selectNotificationsState } from '../../../core.state';
import { Utils } from '../../../utils/utils';

export const selectNotificationCertificationItems = createSelector(
    selectNotificationsState,
    (state) => state.certifications.itemList
);

export const selectNotificationCertificationLoaded = createSelector(
    selectNotificationsState,
    (state) => state.certifications.loaded
);

export const selectNotificationPublicHealthRecords = createSelector(
    selectNotificationsState,
    (state) => state.publicHealthRecords.itemList
);

export const selectNotificationPublicHealthRecordsLoaded = createSelector(
    selectNotificationsState,
    (state) => state.publicHealthRecords.loaded
);

export const selectDocumentNotifications = createSelector(
    selectNotificationCertificationItems,
    selectNotificationPublicHealthRecords,
    (notifications, publicHealthRecords) => notifications.concat(publicHealthRecords)
        .sort((n1, n2) => Utils.sort(n1.createdDate, n2.createdDate, false))
);

